export default function createCountryFormatter(locale) {
  return (countryCode) => {
    if (typeof Intl.DisplayNames !== "function") {
      return countryCode;
    }
    const regionNames = new Intl.DisplayNames([locale], {
      type: "region"
    });
    try {
      return regionNames.of(countryCode) || countryCode;
    } catch {
      return countryCode;
    }
  };
}
